import { Typography } from "antd";
import React, { useState } from "react";
import { CircleLoader } from "react-spinners";
import { useInterval } from "./hook";
import styles from "./circleStyles.less";

const { Title } = Typography;

export default () => {
  const [count, setCount] = useState(0);

  useInterval(() => {
    setCount((count + 1) % 4);
  }, 500);
  const dots = ".".repeat(count) + " ".repeat(4 - count);

  return (
    <div className={styles.loaderBody}>
      <CircleLoader size={100} color={"#468787"} />
      <Title className={styles.loaderTitle} level={3}>
        Loading content<span className={styles.loadingDots}>{dots}</span>
      </Title>
    </div>
  );
};
